module.exports = __webpack_public_path__ + "img/book3.5d764148.png";